import styled from 'styled-components';
import { Container } from '../styled/containers';
import { breakpoint } from '../theme/breakpoint';
import { removeListStyles } from '../styled/utils';

export const Marker = styled.div`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  background: ${({ theme }) => theme.palette.white};
  border: 4px solid ${({ theme }) => theme.palette.borderDark};
  border-radius: 50%;
  margin: 0;
`;

export const Line = styled.div`
  border: ${({ theme }) => `1px solid ${theme.palette.borderDark}`};
  margin-top: 0;
`;

export const LineTop = styled(Line)`
  height: 24px;
  flex-shrink: 0;
`;

export const LineBottom = styled(Line)`
  height: 100%;
  flex: 1;
`;

export const DecorativeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContentWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.xlarge};
  box-shadow: ${({ theme }) => theme.boxshadow.small};
  padding: ${({ theme }) => theme.spacing.standard};
  flex: 1;
`;

export const Heading = styled.h3`
  font-size: ${({ theme }) => theme.fontsize.h4};
  margin-top: 0;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  padding: 0;
`;

export const Content = styled.div`
  padding: 0;
`;

export const ItemWrapper = styled.li`
  display: flex;
  margin-bottom: 0;
  gap: ${({ theme }) => `${theme.spacing.small}`};

  ${breakpoint.tablet`
      gap: ${({ theme }) => `${theme.spacing.standard}`};
  `};
  ${breakpoint.desktop`
      gap: ${({ theme }) => `${theme.spacing.large}`};
  `};

  &:hover ${Marker} {
    background: ${({ theme }) => `${theme.palette.altBackground}`};
  }

  &:hover ${ContentWrapper} {
    box-shadow: ${({ theme }) => theme.boxshadow.standard};
  }

  &:first-of-type ${LineTop} {
    visibility: hidden;
  }

  &:last-of-type ${LineBottom} {
    visibility: hidden;
  }
`;

export const ListWrapper = styled.ul`
  ${removeListStyles}

  & > ${ItemWrapper} {
    counter-increment: none;
    padding-left: 0;
  }

  & > ${ItemWrapper}::before {
    content: none;
    display: none;
  }

  & li::before {
    min-width: 0;
  }
`;

export const TimelineHeading = styled.h2``;

export const TimelineWrapper = styled(Container)`
  margin-top: ${({ theme }) => theme.spacing.medium};
  margin-bottom: ${({ theme }) => theme.spacing.large};
  padding-left: 0;
  padding-right: 0;
`;
